import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import React, { ReactElement } from 'react'

interface ReactQueryProviderProps {
  children: ReactElement
}

const queryClient = new QueryClient()
const environment = process.env.REACT_APP_ENV

export const ReactQueryProvider = ({ children }: ReactQueryProviderProps) => (
  <QueryClientProvider client={queryClient}>
    {children}
    {environment === 'dev' && <ReactQueryDevtools />}
  </QueryClientProvider>
)

export default ReactQueryProvider
